import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';


const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); 

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false); 
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  
  const isHome = location.pathname === '/';

  return (
    <nav className={`navbar navbar-expand-lg navbar-light ${isHome ? 'bg-custom no-shadow' : 'bg-white'}`}>  
      <Link className="navbar-brand" to="/">
        <img
          src="./images/logo.png"
          alt="Logo"
          className="logo"
        />
        Ferretería El Constructor
      </Link>
      <button 
        className="navbar-toggler" 
        type="button" 
        onClick={toggleMenu} 
        aria-expanded={isOpen}
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link className={`nav-link ${isActive('/')}`} to="/" onClick={handleLinkClick}>Inicio</Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('/contacto')}`} to="/contacto" onClick={handleLinkClick}>Contactos</Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('/sucursales')}`} to="/sucursales" onClick={handleLinkClick}>Sucursales</Link>
          </li>
          <li className="nav-item">
            <Link className={`nav-link ${isActive('/reclutamiento')}`} to="/reclutamiento" onClick={handleLinkClick}>Reclutamiento</Link>
          </li>

          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Sitios web</a>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <a className="dropdown-item" href="https://www.elconstructorcayambe.com/subasta-proveedores/login" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>Portal de proveedores</a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.elconstructorcayambe.com/compras/" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>Cartera de proveedores</a>
              </li>
              <li>
                <a className="dropdown-item" href="https://www.elconstructorcayambe.com/jasperserver/login.html" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>Portal de gestión</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;